import React from "react"
import classes from './StudentStatistic.module.css'
import { useSelector } from "react-redux"

const StudentStatistic = ({ statisticData }) => {
    
    const { texts, direction } = useSelector(state => state.translate);

    return (
        <div className={classes.HardTopics}>
            {statisticData &&
                <div className={classes.AssessmentTextWrapper}>
                    <div className={classes.UserNameWrapper}>
                        <div className={classes.UserName}>{statisticData?.userFirstName} {statisticData?.userLastName}</div>
                        {statisticData.userStatistic && statisticData.userStatistic?.isExcellentStudent &&
                            <div className={classes.ExcellentStudent}>
                                <div className={classes.ExcellentStudentIcon}></div>
                                <div className={classes.ExcellentStudentText}>{texts.excellentStudent}</div>
                            </div>
                        }
                    </div>
                    <div className={classes.AssessmentText}>
                        <div className={classes.Numbers}>
                            <div> {statisticData.studentsCount}/<span className={classes.MyAverege}>{statisticData.userStatistic?.rank}</span> {texts.placementInClassroom}</div>

                            <div> {statisticData.assessmentsCount}/<span className={classes.MyAverege}>{statisticData.userStatistic?.submissionsCount} </span>{texts.completionSubjects}</div>
                        </div>
                        <div className={classes.HardSub}>
                            <div className={classes.HardTopicsTitle}>
                                <div className={classes.HardTopicsIcon}></div>

                                <div >{texts.hardTopics}</div>
                            </div>
                            <div className={`${classes[direction]} ${classes.HardTopicNamesContainer}`}>
                                <div className={classes.HardTopicNames}>
                                    {statisticData.userStatistic && statisticData.userStatistic.hardLessons?.map((h, index) =>
                                        <div className={classes.HardTopicName} key={index}>{h}</div>
                                    )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}
        </div >
    )
}
export default StudentStatistic